import styled from 'styled-components';
import { getSpace } from '../../../stylesheets/tools';

const StyledCuratedExhibitionSubHeadline = styled.div`
  .curatedExhibitionSubHeadline__text-container {
    position: relative;
    padding-top: ${getSpace('xl')};
    padding-bottom: ${getSpace('xl')};
    text-align: center;
    margin-top: ${getSpace('xl')};
    span {
      transform: translateX(-15%);
    }
    h2,
    span {
      max-width: 80%;
      margin: auto;
      display: block;
    }
    h2 {
      font-weight: 400;
      font-size: 1.5em;
    }
  }

  .curatedExhibitionSubHeadline__text-container:before {
    content: '';
    border-top: 2px solid ${props => (props.isDarkPage ? 'white' : 'black')};
    position: absolute;
    top: 0;
    left: 25%;
    width: 50%;
  }
`;

export default StyledCuratedExhibitionSubHeadline;
